module.exports = __webpack_public_path__ + "static/media/0_2019_01_20.1019467f.jpg";